import { IOnboardingQuiz, IOnboardingQuizAction, IOnboardingQuizFormData } from 'models/onboardingquiz';
import { IWhoToFollow } from 'models/whotofollow';
import { IStore } from 'redux/IStore';
import { IImageData, ICropImageData, IFollowingItem, IEntityDto } from 'models/common';
import { change } from 'redux-form';
// import { closeModal } from '../modal';
import * as c from 'models/constants';

/** User Preferences actions */
import { getMyUserPreferences } from 'modules/user/userpreferences';
import { accessTokenIsPresent } from 'containers/AccessControl/helpers';
import { getUserProfile } from '../user/userprofile';

/** Action Types */
export const REQUEST_START: string = 'onboardingquiz/REQUEST_START';
export const REQUEST_FAILURE: string = 'onboardingquiz/REQUEST_FAILURE';
export const NEXT_STEP: string = 'onboardingquiz/NEXT_STEP';
export const PREVIOUS_STEP: string = 'onboardingquiz/PREVIOUS_STEP';
export const GET_INFLUENCERS_TO_FOLLOW_SUCCESS: string = 'onboardingquiz/GET_INFLUENCERS_TO_FOLLOW_SUCCESS';
export const GET_SHOPS_TO_FOLLOW_SUCCESS: string = 'onboardingquiz/GET_SHOPS_TO_FOLLOW_SUCCESS';
export const RESET_DATA: string = 'onboardingquiz/RESET_DATA';
export const SUBMIT_ONBOARDING_QUIZ_SUCCESS: string = 'onboardingquiz/SUBMIT_ONBOARDING_QUIZ_SUCCESS';
export const UPDATE_PROFILE_PICTURE_SUCCESS: string = 'onboardingquiz/UPDATE_PROFILE_PICTURE_SUCCESS';
export const SET_STEP: string = 'onboardingquiz/SET_STEP';
export const GET_SUCCESS: string = 'onboardingquiz/GET_SUCCESS';

/** Initial State */
const initialState: IOnboardingQuiz = {
	formData: {},
	influencersToFollow: [],
	shopsToFollow: [],
	wizardStep: 1,
	isFetching: false,
};

/** Reducer */
export function onboardingQuizReducer(state = initialState, action: IOnboardingQuizAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case NEXT_STEP:
			return Object.assign({}, state, {
				wizardStep: state.wizardStep + 1,
			});

		case PREVIOUS_STEP:
			return Object.assign({}, state, {
				wizardStep: state.wizardStep - 1,
			});

		case GET_INFLUENCERS_TO_FOLLOW_SUCCESS:
			return Object.assign({}, state, {
				influencersToFollow: action.payload.influencersToFollow,
				isFetching: false,
			});

		case GET_SHOPS_TO_FOLLOW_SUCCESS:
			return Object.assign({}, state, {
				shopsToFollow: action.payload.shopsToFollow,
				isFetching: false,
			});

		case RESET_DATA:
			return Object.assign({}, state, initialState);

		case SUBMIT_ONBOARDING_QUIZ_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
			});

		case UPDATE_PROFILE_PICTURE_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				formData: action.payload.formData,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function submitOnboardingQuiz(form: IOnboardingQuizFormData) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		if (!form.goals) {
			form.goals = [];
		}

		if (!form.brands) {
			form.brands = [];
		}

		if (!form.hairProducts) {
			form.hairProducts = [];
		}

		if (!form.skinProblems) {
			form.skinProblems = [];
		}

		const userToUpdate: any = { ...form };
		if (userToUpdate.gender !== null) {
			userToUpdate.gender = parseInt(userToUpdate.gender, 10);
		}
		if (userToUpdate.coloredHair === 'Yes') {
			userToUpdate.coloredHair = true;
		} else {
			userToUpdate.coloredHair = false;
		}
		if (!userToUpdate.hairDresserVisitsPerMonth) {
			userToUpdate.hairDresserVisitsPerMonth = 0;
		}

		return fetch(
			getState().fetchDefault.baseAPI + 'api/userquiz',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
				body: JSON.stringify(userToUpdate),
			}),
		)
			.then((res) => {
				// console.log(res);
				if (res.ok) {
					dispatch(submitOnboardingQuizSuccess());
					dispatch(getUserProfile());
					dispatch(getMyUserPreferences());
					dispatch(nextStep());
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Async Action Creator */
export function getInfluencersAndShopsToFollow() {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/user/whotofollow',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IWhoToFollow[]) => {
						const influencersToFollow = res.filter((x) => JSON.parse(x.entityId).type === c.NODE_TYPE_USER);
						dispatch(getInfluencersToFollowSuccess(influencersToFollow));
						dispatch(getInfluencersFollowButtonsData(influencersToFollow.map((item) => ({ entityId: item.entityId }))));

						const shopsToFollow = res.filter((x) => JSON.parse(x.entityId).type === c.NODE_TYPE_SHOP);
						dispatch(getShopsToFollowSuccess(shopsToFollow));
						dispatch(getShopsFollowButtonsData(shopsToFollow.map((item) => ({ entityId: item.entityId }))));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function followInfluencer(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		dispatch(updateInfluencerFollowing(id, undefined));

		return fetch(
			getState().fetchDefault.baseAPI + 'api/user/' + id + '/follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					return res.json().then(() => {
						dispatch(updateInfluencerFollowing(id, true));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function unfollowInfluencer(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		dispatch(updateInfluencerFollowing(id, undefined));

		return fetch(
			getState().fetchDefault.baseAPI + 'api/user/' + id + '/follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					dispatch(updateInfluencerFollowing(id, false));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function followShop(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		dispatch(updateShopFollowing(id, undefined));

		return fetch(
			getState().fetchDefault.baseAPI + 'api/shop/' + id + '/follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					dispatch(updateShopFollowing(id, true));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function unfollowShop(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		dispatch(updateShopFollowing(id, undefined));

		return fetch(
			getState().fetchDefault.baseAPI + 'api/shop/' + id + '/follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					dispatch(updateShopFollowing(id, false));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function updateInfluencerFollowing(id: string, isFollowing: boolean | undefined) {
	return (dispatch, getState: () => IStore) => {
		const influencersToFollow: IWhoToFollow[] = [...(getState().onboardingQuiz.influencersToFollow || [])];
		const indexToUpdate = influencersToFollow.findIndex((x) => JSON.parse(x.entityId).id === id);
		if (indexToUpdate >= 0) {
			influencersToFollow[indexToUpdate] = {
				...influencersToFollow[indexToUpdate],
				following: isFollowing,
			};
		}

		dispatch(getInfluencersToFollowSuccess(influencersToFollow));
	};
}

/** Action Creator */
export function updateShopFollowing(id: string, isFollowing: boolean | undefined) {
	return (dispatch, getState: () => IStore) => {
		const shopsToFollow: IWhoToFollow[] = getState().onboardingQuiz.shopsToFollow;
		const indexToUpdate = shopsToFollow.findIndex((x) => JSON.parse(x.entityId).id === id);
		if (indexToUpdate >= 0) {
			shopsToFollow[indexToUpdate] = {
				...shopsToFollow[indexToUpdate],
				following: isFollowing,
			};
		}

		dispatch(getShopsToFollowSuccess(shopsToFollow));
	};
}

/** Action Creator  */
export function updateProfilePicture(image: ICropImageData) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/userprofile/profileimage',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
				body: JSON.stringify(image),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((newImage: IImageData) => {
						dispatch(updateProfilePictureSuccess());
						dispatch(change(c.FORM_NAME_ONBOARDING_QUIZ, 'picture', newImage.href));
						dispatch(change(c.FORM_NAME_ONBOARDING_QUIZ, 'pictureId', newImage.id));
						// dispatch(closeModal());
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getInfluencersFollowButtonsData(items: IEntityDto[]) {
	return (dispatch, getState: () => IStore) => {
		if (!accessTokenIsPresent()) {
			return Promise.resolve(false);
		}
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/Following',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(items),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(updateInfluencersFollowButtons(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getShopsFollowButtonsData(items: IEntityDto[]) {
	return (dispatch, getState: () => IStore) => {
		if (!accessTokenIsPresent()) {
			return Promise.resolve(false);
		}
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/Following',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(items),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(updateShopsFollowButtons(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function updateInfluencersFollowButtons(items: IFollowingItem[]) {
	return (dispatch, getState: () => IStore) => {
		const influencersToFollow = getState().onboardingQuiz.influencersToFollow;

		if (items !== null) {
			items.map((followingItem: IFollowingItem) => {
				const item: IWhoToFollow = influencersToFollow.filter((i) => i.entityId === followingItem.key.entityId)[0];
				const itemIndex = influencersToFollow.indexOf(item);
				item.following = followingItem.value;
				influencersToFollow[itemIndex] = item;
			});
		} else {
			influencersToFollow.map((item) => {
				item.following = false;
			});
		}

		dispatch(getInfluencersToFollowSuccess(influencersToFollow));
	};
}

/** Action Creator */
export function updateShopsFollowButtons(items: IFollowingItem[]) {
	return (dispatch, getState: () => IStore) => {
		const shopsToFollow = getState().onboardingQuiz.shopsToFollow;

		if (items !== null) {
			items.map((followingItem: IFollowingItem) => {
				const item: IWhoToFollow = shopsToFollow.filter((i) => i.entityId === followingItem.key.entityId)[0];
				const itemIndex = shopsToFollow.indexOf(item);
				item.following = followingItem.value;
				shopsToFollow[itemIndex] = item;
			});
		} else {
			shopsToFollow.map((item) => {
				item.following = false;
			});
		}

		dispatch(getShopsToFollowSuccess(shopsToFollow));
	};
}

/** Action Creator */
export function requestStart(): IOnboardingQuizAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function requestFailure(message: any): IOnboardingQuizAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function nextStep(): IOnboardingQuizAction {
	return {
		type: NEXT_STEP,
	};
}

/** Action Creator */
export function previousStep(): IOnboardingQuizAction {
	return {
		type: PREVIOUS_STEP,
	};
}

/** Action Creator */
export function getInfluencersToFollowSuccess(influencersToFollow: IWhoToFollow[]): IOnboardingQuizAction {
	return {
		type: GET_INFLUENCERS_TO_FOLLOW_SUCCESS,
		payload: {
			influencersToFollow,
		},
	};
}

/** Action Creator */
export function getShopsToFollowSuccess(shopsToFollow: IWhoToFollow[]): IOnboardingQuizAction {
	return {
		type: GET_SHOPS_TO_FOLLOW_SUCCESS,
		payload: {
			shopsToFollow,
		},
	};
}

/** Action Creator */
export function resetData(): IOnboardingQuizAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function submitOnboardingQuizSuccess(): IOnboardingQuizAction {
	return {
		type: SUBMIT_ONBOARDING_QUIZ_SUCCESS,
	};
}

/** Action Creator */
export function updateProfilePictureSuccess(): IOnboardingQuizAction {
	return {
		type: UPDATE_PROFILE_PICTURE_SUCCESS,
	};
}

export function setStep(step?: number): IOnboardingQuizAction {
	return {
		type: SET_STEP,
		payload: {
			wizardStep: step || 0,
		},
	};
}

/** Action Creator */
export function onboardingQuizSuccess(onboarding: IOnboardingQuizFormData): IOnboardingQuizAction {
	return {
		type: GET_SUCCESS,
		payload: {
			formData: onboarding,
		},
	};
}
